import { IBANFFClassification } from '@nkr/models/index'

export interface IValidation {
    treatmentsValid: boolean,
    treatmentTypeOther: boolean,
    dateOfRejectionValid: boolean,
    deNovoDsaPresentValid: boolean,
    persistentDsaPresentValid: boolean,
    wasBiopsyPerformedValid: boolean,
    deNovoDsaValid: boolean,
    persistentDsaValid: boolean,
    persistentDsaOtherValid: boolean,
    reasonValid: boolean,
    isAbnormalValid: boolean,
    acuteAntibodyMediatedRejectionValid: boolean,
    acuteAmrGradeValid: boolean,
    borderlineRejectionValid: boolean,
    acuteTCellMediatedRejectionValid: boolean,
    acuteTcmrGradeValid: boolean,
    chronicActiveTCellMediatedRejectionValid: boolean,
    interstitialFibrosisAndTubularAtrophyValid: boolean,
    iftaGradeValid: boolean,
    c4dStainingWithoutEvidenceOfRejectionValid: boolean,
    otherFindingsValid: boolean,
}

export interface IRejection {
    dateOfRejection: Date | null,
    deNovoDsaPresent: number | null,
    persistentDsaPresent: number | null,
    biopsyPerformed: number | null,
    biopsyReason: number | null,
    biopsyIsAbnormal: number | null,
    acuteAntibodyMediatedRejection: number | null,
    acuteAmrGrade: number | null,
    borderlineRejection: number | null,
    acuteTCellMediatedRejection: number | null,
    acuteTcmrGrade: number | null,
    chronicActiveTCellMediatedRejection: number | null,
    interstitialFibrosisAndTubularAtrophy: number | null,
    iftaGrade: number | null,
    c4dStainingWithoutEvidenceOfRejection: number | null,
    otherFindings: string
}

export const cleanRejection: IRejection = {
    dateOfRejection: null,
    deNovoDsaPresent: null,
    persistentDsaPresent: null,
    biopsyPerformed: null,
    biopsyReason: -1,
    biopsyIsAbnormal: null,
    acuteAntibodyMediatedRejection: null,
    acuteAmrGrade: -1,
    borderlineRejection: null,
    acuteTCellMediatedRejection: null,
    acuteTcmrGrade: -1,
    chronicActiveTCellMediatedRejection: null,
    interstitialFibrosisAndTubularAtrophy: null,
    iftaGrade: -1,
    c4dStainingWithoutEvidenceOfRejection: null,
    otherFindings: ''
};

export const cleanBANFF: IBANFFClassification = {
    id: 0,
    biopsyId: 0,
    tubulitis: -1,
    intimalArteritis: -1,
    c4d: -1,
    interstitialFibrosis: -1,
    tubularAtrophy: -1,
    vascularFibrousIntimalThickening: -1,
    mesangialMatrixExpansion: -1,
    arterioloarHyalinosis: -1,
    hyalineArterioloarThickening: -1,
    totalInflammation: -1,
    inflammationInAreaOfIfta: -1,
    interstitialInflammation: -1,
    glomerulitis: -1,
    peritubularCapillaritis: -1,
    gbmDoubleContours: -1,
    tifta: -1,
    pvl: -1
};

export interface ICleanOtherDetails {
    nonHla: boolean,
    other: boolean,
    otherDetails: string
}

export const cleanOtherDsaDetails: ICleanOtherDetails = {
    nonHla: null,
    other: null,
    otherDetails: ''
};

export const validationState: IValidation = {
    treatmentsValid: true,
    treatmentTypeOther: true,
    dateOfRejectionValid: true,
    deNovoDsaPresentValid: true,
    persistentDsaPresentValid: true,
    wasBiopsyPerformedValid: true,
    deNovoDsaValid: true,
    persistentDsaValid: true,
    persistentDsaOtherValid: true,
    reasonValid: true,
    isAbnormalValid: true,
    acuteAntibodyMediatedRejectionValid: true,
    acuteAmrGradeValid: true,
    borderlineRejectionValid: true,
    acuteTCellMediatedRejectionValid: true,
    acuteTcmrGradeValid: true,
    chronicActiveTCellMediatedRejectionValid: true,
    interstitialFibrosisAndTubularAtrophyValid: true,
    iftaGradeValid: true,
    c4dStainingWithoutEvidenceOfRejectionValid: true,
    otherFindingsValid: true,
};